import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { GameDayModel } from '../../models/gameday-model';
import { MonitorBasePageService } from './monitor-base-page.service';
import {
  byRetailTypeLegendExtractor,
  getIdByRetailType
} from '../../gameday/mappers/gameDay.extractors';
import { orderIsLowPriorityType } from '../../gameday/data/gameDay-data-orders.calculation';
import { GameDayRootReducerState } from '../../state/root.state';
import { BarChartLegend } from '../../shared/models/charts/chart-data-types';

@Injectable()
export class MonitorRetailPageService extends MonitorBasePageService {
  private baseRetailCategoryIds: string[] = [
    getIdByRetailType(undefined, GameDayModel.OrderPriority.retail, true),
    getIdByRetailType(undefined, GameDayModel.OrderPriority.retail, false)
  ];

  constructor(store: Store<GameDayRootReducerState>) {
    super(store);
  }

  public extractCategories(
    deal: GameDayModel.Deal,
    orders: GameDayModel.Order[]
  ): BarChartLegend[] {
    return byRetailTypeLegendExtractor(deal, orders);
  }

  public getCategoriesNames(
    categoriesMap: Map<string, BarChartLegend>,
    order: GameDayModel.Order,
    deal: GameDayModel.Deal
  ): string[] {
    const result: string[] = [];
    const id = getIdByRetailType(
      order.category,
      GameDayModel.OrderPriority.retail,
      deal.categories && deal.categories.length
        ? false
        : orderIsLowPriorityType(order)
    );

    const category = categoriesMap.get(id);

    if (category) {
      result.push(categoriesMap.get(id).name);
    }

    return result;
  }

  public containsNotRetailsCategories(
    categoryLegends: BarChartLegend[]
  ): boolean {
    return (
      _(categoryLegends)
        .map((c) => c.id)
        .without(...this.baseRetailCategoryIds)
        .value().length > 0
    );
  }
}
